module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.30799efa5bf74129468a.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Regular-webfont.eot
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular-webfont.eot
// module chunks = styles